import { urls } from "../../../../constants/constants";

export default class Fetch {
  static getUsers(userId, status, offset, search, tag="") {
    return new Promise((resolve, reject) => {
      fetch(
        `${
          urls.aspariaBackend
        }api/v1/patient/getPatients?flag=${status}&pageNo=${offset}&pageSize=15&search=${search}&tag=${tag}`,
        {
          headers: {
            method: "GET",
            accept: "application/json",
            Authorization: `Bearer `,
          },
          credentials: "include",
        }
      )
        .then((data) => {
          return data.json();
        })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static getUserDetails(phone, forEdit = true) {
    return new Promise((resolve, reject) => {
      fetch(
        `${urls.aspariaBackend}api/v1/patient/getByNumber?cellPhone=${phone}&forEdit=${forEdit}`,
        {
          headers: {
            method: "GET",
            accept: "application/json",
            Authorization: `Bearer `,
          },
          credentials: "include",
        }
      )
        .then((data) => {
          return data.json();
        })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
